import React, { forwardRef } from 'react';
import Button, { ButtonProps } from '../Button';
import CircularProgress from '../CircularProgress';

interface LoadingButtonProps extends ButtonProps {
  /**
   * if `true`, loading icon will be visible
   */
  loading?: boolean;
}

const LoadingButton = forwardRef<HTMLButtonElement, LoadingButtonProps>(
  (props, ref) => {
    const { loading = true, ...rest } = props;

    return (
      <Button
        {...rest}
        startIcon={loading && <CircularProgress size="1rem" color="inherit" />}
        ref={ref}
      />
    );
  }
);

LoadingButton.displayName = 'LoadingButton';

export default LoadingButton;
